import { gql } from "@apollo/client";

export const GET_QUESTIONNAIRE = gql`
  query {
    questionnaire {
      firstName
      lastName
      birthLastName
      email
      phone
      birthNumber
      birthDate
      birthPlace
      state
      nationality
      maritalStatus
      customText
      customText2
      customText3
      isForeigner
      isBankAccountShow
      bankAccountNumber
      permanentAddressCity
      permanentAddressStreet
      permanentAddressPostnumber
      isContactAddressDifferent
      contactAddressCity
      contactAddressStreet
      contactAddressPostnumber
      children
      insuranceNumber
      insuranceCompany
      isHandicap
      isOtherEmployment
      idCardType
      idCardNumber
      idCardValidDate
      employmentOrigin
      isSeizure
      seizureNumber
      isTradeLicense
      tradingLicenseNumber
      isDeliverFileLater
      isCriminalRecord
      educationLevel
      educationCode
      isEducationDeliverFileLater
      isNoInsuranceCompany
      typeOfCandidate
      otherHealthInsurancePayer
      companyIdentificationNumber

      employeeFile {
        id
        filename
        createdAt
      }

      otherDocuments {
        id
        filename
        createdAt
      }

      foreignerDocuments {
        id
        filename
        createdAt
      }

      educationDocuments {
        id
        filename
        createdAt
      }

      healthInsurancePayerDocuments {
        id
        filename
        createdAt
      }

      updatedAt
    }
  }
`;

export const GET_QUESTIONNAIRE_REQUIRED = gql`
  query {
    questionnaire {
      firstName
      lastName
      birthLastName
      phone
      birthNumber
      birthDate
      birthPlace
      state
      nationality
      maritalStatus
      isForeigner
      isBankAccountShow
      bankAccountNumber
      permanentAddressCity
      permanentAddressStreet
      permanentAddressPostnumber
      isContactAddressDifferent
      contactAddressCity
      contactAddressStreet
      contactAddressPostnumber
      children
      insuranceNumber
      insuranceCompany
      isHandicap
      isOtherEmployment
      idCardNumber
      idCardValidDate
      employmentOrigin
      isSeizure
      seizureNumber
      isTradeLicense
      tradingLicenseNumber
      isDeliverFileLater
      isCriminalRecord
      educationLevel
      educationCode
      isEducationDeliverFileLater
      isNoInsuranceCompany
      typeOfCandidate
      otherHealthInsurancePayer
      companyIdentificationNumber

      employeeFile {
        id
        filename
        createdAt
      }

      otherDocuments {
        id
        filename
        createdAt
      }

      foreignerDocuments {
        id
        filename
        createdAt
      }

      educationDocuments {
        id
        filename
        createdAt
      }

      healthInsurancePayerDocuments {
        id
        filename
        createdAt
      }
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation logout {
    logout
  }
`;

export const UPDATE_QUESTIONNAIRE = gql`
  mutation questionnaireUpdateClient($input: QuestionnaireUpdateInputClient!) {
    questionnaireUpdateClient(input: $input) {
      firstName
      lastName
      birthLastName
      phone
      birthNumber
      birthDate
      birthPlace
      state
      nationality
      maritalStatus
      isForeigner
      isBankAccountShow
      bankAccountNumber
      permanentAddressCity
      permanentAddressStreet
      permanentAddressPostnumber
      isContactAddressDifferent
      contactAddressCity
      contactAddressStreet
      contactAddressPostnumber
      children
      insuranceNumber
      insuranceCompany
      isHandicap
      isOtherEmployment
      idCardNumber
      idCardValidDate
      updatedAt
      employmentOrigin
      isSeizure
      seizureNumber
      isTradeLicense
      tradingLicenseNumber
      isDeliverFileLater
      isCriminalRecord
      educationLevel
      educationCode
      isEducationDeliverFileLater
      isNoInsuranceCompany
      typeOfCandidate
      otherHealthInsurancePayer
      companyIdentificationNumber

      employeeFile {
        id
        filename
        createdAt
      }

      otherDocuments {
        id
        filename
        createdAt
      }

      foreignerDocuments {
        id
        filename
        createdAt
      }

      educationDocuments {
        id
        filename
        createdAt
      }

      healthInsurancePayerDocuments {
        id
        filename
        createdAt
      }
    }
  }
`;

export const ENUM_INSURANCE = gql`
  query enumerations {
    enumerations(type: POJISTOVNA) {
      id
      text
    }
  }
`;

export const ENUM_MARITAL_STATUS = gql`
  query enumerations {
    enumerations(type: RODINNY_STAV) {
      id
      text
    }
  }
`;

export const ENUM_PREV_WORK = gql`
  query enumerations {
    enumerations(type: PREV_WORK) {
      id
      text
    }
  }
`;

export const ENUM_COUNTRY = gql`
  query enumerations {
    enumerations(type: COUNTRY) {
      id
      text
      value
    }
  }
`;

export const ENUM_EDUCATION = gql`
  query enumerations {
    enumerations(type: VZDELANI) {
      id
      text
      value
    }
  }
`;
